import { createPortal } from "react-dom";
import { LiveInterviewPresentingStage } from "./LiveInterviewPresentingStage";

/** Covers the full browser tab while sharing so capture never includes live share video. */
export function LiveInterviewPresentingPortal({ active }) {
  if (!active || typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="li-presenting-portal" aria-hidden="true">
      <LiveInterviewPresentingStage
        title="You're presenting to everyone"
        subtitle="Others can see your screen."
      />
    </div>,
    document.body,
  );
}
